import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaQuestionCircle, FaTrash, FaCheckCircle, FaExclamationCircle, FaPlus } from "react-icons/fa";
import Pagination from "Components/Pagination";
import InquiryDetail from "Components/InquiryDetail";
import InquiryCreateModal from "Components/InquiryCreateModal";
import CommonModal from "Components/CommonModal";
import { catchError, changeState, commonModalSetting } from "JS/common";
import { getInquiryList } from "JS/API";
import { inquiryDelete } from "JS/API"; // 임시 문의 사항 삭제 api 추후 수정 필요
import { useMarkMenuSeen } from "Contexts/NewCountContext";
import $ from "jquery";
import { listPageStyles } from "utils/designSystem";

const Inquiry = () => {
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    totalPage: 1,
    limit: 10,
  });
  const [select, setSelect] = useState("all"); // 전체 보기 디폴트
  const [id, setId] = useState(""); // 문의 사항 id
  const [alert, setAlert] = useState(""); // 알림 메시지
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const [list, setList] = useState([]);
  const [modal, setModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  // 체크된 문의사항 ID들을 저장하는 상태
  const [idArr, setIdArr] = useState([]);
  const navigate = useNavigate();
  useMarkMenuSeen("inquiry");

  let prevent = false;

  // 문의 유형 필터링
  const [inquiryType, setInquiryType] = useState("all");

  // 스타일 정의
  const styles = {
    container: listPageStyles.container,
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '16px'
    },
    title: listPageStyles.title,
    controlsContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      flexWrap: 'wrap',
      minWidth: 0
    },
    select: listPageStyles.select,
    deleteButton: listPageStyles.deleteButton,
    createButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      backgroundColor: '#2563eb',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    autoBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '2px 8px',
      borderRadius: '4px',
      fontSize: '11px',
      fontWeight: '600',
      backgroundColor: '#fee2e2',
      color: '#b91c1c',
      marginLeft: '8px',
      verticalAlign: 'middle'
    },
    tableContainer: listPageStyles.tableContainer,
    tableWrapper: listPageStyles.tableWrapper,
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: '700px'
    },
    th: listPageStyles.th,
    td: listPageStyles.td,
    checkbox: listPageStyles.checkbox,
    checkboxLabel: listPageStyles.checkboxLabel,
    statusCompleted: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      color: '#059669',
      fontWeight: '600'
    },
    statusPending: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      color: '#dc2626',
      fontWeight: '600'
    },
    inquiryType: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      textAlign: 'center'
    },
    typeRegist: {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8'
    },
    typeMark: {
      backgroundColor: '#dcfce7',
      color: '#16a34a'
    },
    typeInquiry: {
      backgroundColor: '#fef3c7',
      color: '#d97706'
    },
    typeEtc: {
      backgroundColor: '#f3e8ff',
      color: '#7c3aed'
    },
    titleCell: {
      fontWeight: '500',
      color: '#374151'
    },
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 24px',
      color: '#64748b',
      fontSize: '16px'
    }
  };

  // 문의 유형별 스타일 반환
  const getInquiryTypeStyle = (type) => {
    const baseStyle = styles.inquiryType;
    switch (type) {
      case '등록가능성 문의':
        return { ...baseStyle, ...styles.typeRegist };
      case '상표등록신청':
        return { ...baseStyle, ...styles.typeMark };
      case '상표 문의':
        return { ...baseStyle, ...styles.typeInquiry };
      case '기타':
        return { ...baseStyle, ...styles.typeEtc };
      default:
        console.log('Unknown inquiry type:', type); // 디버깅용
        return { ...baseStyle, ...styles.typeEtc };
    }
  };

  // 문의 유형 텍스트 반환
  const getInquiryTypeText = (type) => {
    switch (type) {
      case '등록가능성 문의':
        return '등록가능성 문의';
      case '상표등록신청':
        return '상표등록신청';
      case '상표 문의':
        return '상표 문의';
      case '기타':
        return '기타';
      default:
        console.log('Unknown inquiry type for text:', type); // 디버깅용
        return type || '기타'; // 실제 값을 표시하거나 기타
    }
  };


  //= 문의 사항 불러오기
  const getInquiry = async () => {
    // 문의 사항 불러오기
    if (prevent) return; // 중복 호출 방지
    prevent = true; // 중복 호출 방지
    setTimeout(() => {
      // 200ms 뒤에 실행
      prevent = false; // 중복 호출 방지 해제
    }, 200);

    const result = await getInquiryList(
      pageInfo.page,
      pageInfo.limit,
      select,
      inquiryType
    ); // 문의 사항 불러오기
    if (typeof result === "object") {
      setList(result?.data?.data);
      changeState(setPageInfo, "totalPage", result?.data?.meta?.total_page);
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  //= 문의 사항 테이블 렌더
  const renderTableBody = () => {
    return list.map(
      ({ title, created_at, user_name, status_flag, id, inquiry_type, is_auto }) => {
        // 개별 선택
        const checkEach = (e) => {
          e.stopPropagation(); // 체크박스에서 모달 금지
          let all = $(".inquiry-check").length;
          let checked = $(".inquiry-check:checked").length;
          let arr = [];
          if (all !== checked) $(".inquiry-all-check").prop("checked", false);
          else $(".inquiry-all-check").prop("checked", true);
          for (let i = 0; i < all; i++) {
            if (document.getElementsByClassName("inquiry-check")[i].checked) {
              const val =
                document.getElementsByClassName("inquiry-check")[i].value;
              arr.push(val);
              setIdArr(arr);
            }
          }
        };

        //& 목록 클릭 시 실행할 함수
        const onModal = () => {
          setModal(true);
          setId(id);
        };

        return (
          <tr 
            key={id}
            onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
            onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
          >
            <td style={styles.td} onClick={(e) => e.stopPropagation()}>
              <label style={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  className="inquiry-check"
                  onChange={checkEach}
                  value={id}
                  style={styles.checkbox}
                />
              </label>
            </td>
            <td style={styles.td} onClick={onModal}>
              <span style={getInquiryTypeStyle(inquiry_type)}>
                {getInquiryTypeText(inquiry_type)}
              </span>
            </td>
            <td style={{...styles.td, ...styles.titleCell}} onClick={onModal}>
              {title}
              {is_auto && <span style={styles.autoBadge}>임의글</span>}
            </td>
            <td style={styles.td} onClick={onModal}>{created_at.split("T")[0]}</td>
            <td style={styles.td} onClick={onModal}>{user_name}</td>
            <td style={styles.td} onClick={onModal}>
              {status_flag ? (
                <span style={styles.statusCompleted}>
                  <FaCheckCircle size={12} />
                  완료
                </span>
              ) : (
                <span style={styles.statusPending}>
                  <FaExclamationCircle size={12} />
                  미답변
                </span>
              )}
            </td>
          </tr>
        );
      }
    );
  };

  // 문의사항 다중 삭제
  const deleteInquiries = async () => {
    const data = idArr; // 배열 전체를 사용
    const result = await inquiryDelete({ inquiry_ids: data });
    if (typeof result === "object") {
      commonModalSetting(setAlertBox, true, "alert", "삭제되었습니다.");
      $(".inquiry-all-check").prop("checked", false);
      $(".inquiry-check").prop("checked", false);
      changeState(setPageInfo, "page", 1);
      setIdArr([]);
      setAlert("completeDelete");
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "정상적으로 삭제되었습니다."
      );
      getInquiry();
    } else {
      return await catchError(result, navigate, setAlertBox, setAlert);
    }
  };

  // 전체 선택
  const checkAll = () => {
    let arr = [];
    if ($(".inquiry-all-check").is(":checked")) {
      $(".inquiry-check").prop("checked", true);
      const all = $(".inquiry-check").length;
      for (let i = 0; i < all; i++) {
        const val = document.getElementsByClassName("inquiry-check")[i].value;
        arr.push(val);
        setIdArr(arr);
      }
    } else {
      $(".inquiry-check").prop("checked", false);
      setIdArr([]);
    }
  };

  useEffect(() => {
    document.title = "마크픽 관리자 > 문의 사항 관리";
  }, []);

  // 의존성 배열 추가 InquiryType이 변경될 때마다 getInquiry함수를 다시 호출하도록 함
  useEffect(() => {
    if (!modal) {
      getInquiry();
    }
  }, [pageInfo.page, pageInfo.limit, modal, select, inquiryType]);

  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <div style={styles.header}>
        <h1 style={styles.title}>
          <FaQuestionCircle />
          INQUIRY
        </h1>
        
        <div style={styles.controlsContainer} className="controls-container">
          <select
            value={pageInfo.limit}
            onChange={(e) => {
              setPageInfo((prev) => {
                const clone = { ...prev };
                clone.page = 1;
                clone.limit = e.target.value;
                return clone;
              });
            }}
            style={styles.select}
          >
            <option value={10}>10개씩 보기</option>
            <option value={30}>30개씩 보기</option>
            <option value={50}>50개씩 보기</option>
          </select>
          
          <select
            value={select}
            onChange={(e) => {
              setSelect(e.target.value);
              changeState(setPageInfo, "page", 1);
            }}
            style={styles.select}
          >
            <option value="all">전체보기</option>
            <option value="notanswer">미답변 문의</option>
            <option value="answer">답변 완료</option>
          </select>
          
          {/* 문의 유형 필터링 */}
          <select
            value={inquiryType}
            onChange={(e) => {
              setInquiryType(e.target.value);
              changeState(setPageInfo, "page", 1);
            }}
            style={styles.select}
          >
            <option value="all">모든 문의 유형</option>
            <option value="regist_availability">등록가능성 문의</option>
            <option value="mark_regist">상표등록신청</option>
            <option value="mark_inquery">상표 문의</option>
            <option value="etc">기타(서비스불편사항)</option>
          </select>

          <button
            style={styles.createButton}
            onClick={() => setCreateModal(true)}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
          >
            <FaPlus />
            <span className="button-text">임의글 작성</span>
          </button>

          <button
            style={styles.deleteButton}
            onClick={() => {
              if (!idArr.length)
                return commonModalSetting(
                  setAlertBox,
                  true,
                  "alert",
                  "삭제할 문의사항을 선택해 주세요."
                );
              else {
                setAlert("deleteConfirm");
                commonModalSetting(
                  setAlertBox,
                  true,
                  "confirm",
                  "선택한 문의사항을 삭제하면 다시 복구할 수 없습니다.<br/>정말 삭제하시겠습니까?"
                );
              }
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
          >
            <FaTrash />
            <span className="button-text">삭제</span>
          </button>
        </div>
      </div>

      {/* 테이블 */}
      <div style={styles.tableContainer}>
        {list?.length ? (
          <div style={styles.tableWrapper} className="table-wrapper">
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>
                    <label style={styles.checkboxLabel}>
                      <input
                        type="checkbox"
                        className="inquiry-all-check"
                        onChange={checkAll}
                        style={styles.checkbox}
                      />
                    </label>
                  </th>
                  <th style={styles.th}>문의 유형</th>
                  <th style={styles.th}>제목</th>
                  <th style={styles.th}>등록일</th>
                  <th style={styles.th}>작성자</th>
                  <th style={styles.th}>상태</th>
                </tr>
              </thead>
              <tbody>{renderTableBody()}</tbody>
            </table>
          </div>
        ) : (
          <div style={styles.emptyState}>목록이 없습니다.</div>
        )}
      </div>

      {/* 페이지네이션 */}
      <Pagination pageInfo={pageInfo} setPageInfo={setPageInfo} />

      {/* 모달들 */}
      {modal ? <InquiryDetail inquiryId={id} setModal={setModal} /> : ""}
      {createModal ? (
        <InquiryCreateModal
          setModal={setCreateModal}
          onSuccess={() => {
            changeState(setPageInfo, "page", 1);
            getInquiry();
          }}
        />
      ) : ""}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
            else if (alert === "deleteConfirm") {
              deleteInquiries(); // 삭제 함수 호출
            }
          }}
        />
      )}

      {/* 반응형 스타일 */}
      <style>{`
        @media (max-width: 768px) {
          .table-wrapper {
            -webkit-overflow-scrolling: touch;
          }
          
          .table-wrapper::-webkit-scrollbar {
            height: 8px;
          }
          
          .table-wrapper::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
        }
        
        @media (max-width: 640px) {
          .controls-container {
            justify-content: center;
          }
          
          .button-text {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default Inquiry;